/* eslint-disable max-len */
export const survey = {
  questionnaire: 'Anketa',
  survey: 'Anketa olish',
  question: 'Savol',
  'survey-finished': 'Anketa yakunlandi. Rahmat!',
  'answers-successfuly-sent': 'Anketa yakunlandi. Rahmat!',
  'to-next-stage': 'Keyingi bosqichga oʻtish',
  'nth-question-from-x': 'Savol: {current} / {total}',
  'response-time': 'Javob vaqti',
  'finish-questionnaire': 'Anketani yakunlash',
  'next-question': 'Keyingi savol',
  'video-interview': 'Video intervyu',
  'selection-stages': 'Saralash bosqichlari',
  'start-interview-notice': 'Video intervyu topshirish uchun savollarga javobni yozib olish zarur. Savollarni matnli formatda yoki video formatda berish mumkin. Yozib olish uchun kamera va mikrofonli kompyuter, smartfon yoki planshet talab qilinadi.',
};
